/**
* 共通メッセージ（日本語） 
*/

export const map = new Map([

    /* Product information */
    // ['product.name','メモった！'],
    
    /* URL */
    ['url.regi','https://www.memotta.com/'],
    ['url.login','https://www.memotta.com/'],
    ['url.home','https://www.memotta.com/'],
    
    /* Message */
    ['msg.0001','システムエラーが発生しました。'],
    ['msg.0002','パスワードが正しくありません。'],
    ['msg.0003','接続がタイムアウトになりましたので再度ログインして下さい。'],
    ['msg.0004','入力されたEメールアドレスは既に登録されてます。'],
    ['msg.0005','入力されたEメールアドレスは現在登録手続き中です。'],
    ['msg.0006','入力されたEメールアドレスが正しくありません。'],
    ['msg.0007','入力されたEメールアドレスは無効です。'],
    ['msg.0008','該当するメモは見つかりませんでした。'],
    ['msg.0009','入力されたニックネームは既に登録されてます。'],
    ['msg.0010','保存しました。'],
    ['msg.0011','アカウント削除処理を行いますか？'],
    ['msg.0012','メモの内容を全て削除する場合は、メモ検索結果画面から削除を行って下さい。'],
    ['msg.0013','記録可能画像サイズの合計が上限に達しましたのでこれ以上記録することが出来ません。古い画像を削除するか、無料プランをご利用のお客様は、有料プランを購入頂く事により上限を増やす事が出来ます。'],
    ['msg.0014','１日あたりのメモ記録件数の上限に達しましたので、本日はこれ以上メモ記録は出来ません。無料プランをご利用のお客様は、有料プランを購入頂く事により上限を増やす事が出来ます。'],
    ['msg.0015','参照ボタンで画像ファイルを指定して下さい'],
    ['msg.0016','選択した画像を削除しても宜しいですか？'],
    ['msg.0017','画像を削除しました。'],
    ['msg.0018','メモ、画像共に削除しました。'],
    ['msg.0019','メモを削除しました。'],
    ['msg.0020','画像の保存に失敗しました。'],
    ['msg.0021','過去日数を選択して下さい。'],
    ['msg.0022','身長は半角数字で入力して下さい。例） 166.5'],
    ['msg.0023','体重は半角数字で入力して下さい。例） 55.5'],
    ['msg.0024','日付の形式が正しくありません。例） 2011/02/11'],
    ['msg.0025','日付の範囲が正しくありません。'],
    ['msg.0026','選択したメモ、画像を削除しても宜しいですか？'],
    ['msg.0027','メモが選択されていないか存在しません。'],
    ['msg.0028','メモ、画像が削除出来ませんでした。'],
    ['msg.0029','画像アップロード失敗。登録可能な画像フォーマットは bmp, gif, jpg(jpeg), png のみです。'],
    ['msg.0030','メモの保存に失敗しました。タイトル、メモ又は画像を入力して下さい。'],
    ['msg.0031','開始時刻は終了時刻より前に設定して下さい。'],
    ['msg.0032','備考を保存しました。'],
    ['msg.0033','Eメールアドレスが正しくありません。'],
    ['msg.0034','権限がありません。'],
    ['msg.0035','削除しました。'],
    ['msg.0036','Eメールアドレスを入力して下さい。'],
    ['msg.0037','パスワードを入力して下さい。'],
    ['msg.0038','パスワードの文字数を確認して下さい。'],
    ['msg.0039','ニックネームを入力して下さい。'],
    ['msg.0040','ニックネームの文字数を確認して下さい。'],
    ['msg.0041','変更箇所が無いため保存しませんでした。'],
    ['msg.0042','年月日を指定して下さい。'],
    ['msg.0043','システムエラー：ユーザーIDが正しくありません。'],
    ['msg.0044','検索条件を正しく入力して下さい。'],
    ['msg.0045','検索結果件数が上限に達しましたので上限までを表示します。'],
    ['msg.0046','メモを保存しました。'],
    ['msg.0047','画像を保存しました。'],
    ['msg.0048','画像アップロード失敗。'],
    ['msg.0049','年月日を入力して下さい。'],
    ['msg.0050','体重を入力して下さい。'],
    ['msg.0051','終了しますか？'],
    ['msg.0052','料金プランの変更申込みを受け付けました。弊社より24時間以内に確認メールが送信されますのでしばらくお待ち下さい。'],
    ['msg.0053','アクションフラグの値が正しくありません。'],
    ['msg.0054','入力された２つのパスワードが等しくありません。'],
    ['msg.0055','パスワードに使用されている文字が正しくありません。使用できる文字を確認して下さい。'],
    ['msg.0056','パスワードに空白文字を含むことは出来ません。'],
    ['msg.0057','生年月日を入力して下さい。'],
    ['msg.0058','居住地（県又は国）を入力して下さい。'],
    ['msg.0059','アカウント仮登録が完了しました。ご登録Eメールアドレスにアカウント登録確認メールが送信されますのでログインを行って下さい。アカウント登録確認メールが届かない場合は、お手数ですが再度ご登録のお手続きを行って下さい。なお、gmailをご利用の方はアカウント登録確認メールが「迷惑メールフォルダー」に入る場合が御座いますので、「受信フォルダー」にメールが見つからない場合は「迷惑メールフォルダー」をご確認下さい。'],
    ['msg.0060','お問い合せ内容を入力して下さい。'],
    ['msg.0061','プロフィールを変更しました。再度ログインを行って下さい。'],
    ['msg.0062','パスワードを変更しました。再度ログインを行って下さい。'],
    ['msg.0063','これ以上拡大出来ません。'],
    ['msg.0064','これ以上縮小出来ません。'],
    ['msg.0065','血圧には数字を入力して下さい。'],
    ['msg.0066','血圧を正しく入力して下さい。'],
    ['msg.0067','脈拍には数字を入力して下さい。'],
    ['msg.0068','選択した行を削除しても宜しいですか？'],
    ['msg.0069','体温には数字を入力して下さい。'],
    ['msg.0070','グループ名を入力して下さい。'],
    ['msg.0071','説明を入力して下さい。'],
    ['msg.0072','グループ名は既に存在しています。'],
    ['msg.0073','メール送信に失敗しました。'],
    ['msg.0074','招待メールを送信して宜しいですか？'],
    ['msg.0075','メールを送信しました。'],
    ['msg.0076','開始年月日を入力して下さい。'],
    ['msg.0077','表示項目を１つ以上選択して下さい。'],
    ['msg.0078','表示データーがありません。'],
    ['msg.0079','選択数の上限に達しましたのでこれ以上は選択は出来ません。'],
    ['msg.0080','未回答のグループ招待に回答して下さい。'],
    ['msg.0081','無料プランではこれ以上グループを登録出来ません。有料プランを購入されますか？'],
    ['msg.0082','現在のプランではこれ以上グループを登録出来ません。更に登録が必要な場合はお問合せ下さい。'],
    ['msg.0083','有料プランから無料プランに変更するにはグループ一覧画面でグループ数を無料プランのグループ上限数まで減らして下さい。<br><b>無料プランのグループ上限数：</b>'],
    ['msg.0084','無料プランに変更するにはグループ一覧内のメンバー数を無料プランのメンバー上限数まで減らして下さい。<br><b>無料プランのメンバー上限数：</b>'],
    ['msg.0085','無料プランではこれ以上メンバーを登録出来ません。有料プランを購入されますか？'],
    ['msg.0086','現在のプランではこれ以上メンバーを登録出来ません。更に登録が必要な場合はお問合せ下さい。'],
    ['msg.0087','無料プランではこれ以上グループを登録出来ません。有料プランを購入するにはAndroid又はiPhoneから再度操作を行って下さい。'],
    ['msg.0088','無料プランではこれ以上メンバーを登録出来ません。有料プランを購入するにはAndroid又はiPhoneから再度操作を行って下さい。'],
    ['msg.0089','目標達成予定日を入力して下さい。'],
    ['msg.0090','現在購入頂けません。もうしばらくしてからお試し下さい。'],
    ['msg.0091','有料プランの購入はAndroid又はiPhoneから操作を行って下さい。'],
    ['msg.0092','グループ（{$1}）を削除しても宜しいですか？一度削除すると元に戻す事は出来ません。'],
    ['msg.0093','メンバー（{$1}）を除外しても宜しいですか？'],
    ['msg.0094','メンバーを選択するか、「全員」ボタンを押して下さい。'],
    ['msg.0095','除外しました。'],
    ['msg.0096','{$1}のパスワードが変更され、新しいパスワードが{$1}に送信されます。処理を続けますか？'],
    ['msg.0097','新しいパスワードを{$1}に送信しました。'],
    ['msg.0098','グラフ作成処理でエラーが発生しました。'],
    ['msg.0099','保存に失敗しました。'],
    ['msg.0100','タイトルを入力して下さい。'],
    ['msg.0101','公開終了日時は公開開始日時以降の日時を指定して下さい。'],
    ['msg.0102','開始時刻より過去の時刻は設定できませんので開始時刻又はリマインダーを設定し直して下さい。'],
    ['msg.0103','イベント情報が存在しません。'],
    ['msg.0104','イベントが削除出来ませんでした。'],
    ['msg.0105','選択したイベントを削除しても宜しいですか？'],
    ['msg.0106','繰り返し終了年月日を入力して下さい。'],
    ['msg.0107','指定曜日を選択して下さい。'],
    ['msg.0108','指定日を選択して下さい。'],
    ['msg.0109','選択したイベントと同時に登録された全ての繰り返しイベントを削除しても宜しいですか？'],
    ['msg.0110','送信先を選択して下さい。'],
    ['msg.0111','イベントが登録されました。'],
    ['msg.0112','イベントが変更されました。'],
    ['msg.0113','イベントが削除されました。'],
    ['msg.0114','出欠を選択して下さい。'],
    ['msg.0115','送信メッセージを入力して下さい。'],
    ['msg.0116','送信先を選択して下さい。'],
    ['msg.0117','添付ファイルアップロード失敗。'],
    ['msg.0118','1MB以上のファイルは送信できません。'],
    ['msg.0119','バーコード/QRコード作成処理でエラーが発生しました。'],
    ['msg.0120','クーポン名称を入力して下さい。'],
    ['msg.0121','表示順には1から9999までの数字を入力して下さい。'],
    ['msg.0122','画像を削除します。削除確認後、保存ボタンを押して下さい。'],
    ['msg.0123','クーポンコードを正しく入力して下さい。'],
    ['msg.0124','他のEメールアドレスで既に有料オプションは購入済みです。追加購入の場合はお問合わせ下さい。'],
    ['msg.0125','削除に失敗しました。'],
    ['msg.0126','連続日数は1～9の半角数字を入力して下さい。'],
    ['msg.0127','通知条件を選択、設定して下さい。'],
    ['msg.0128','ファイル選択後、保存ボタンを押して下さい。'],
    ['msg.0129','お使いの端末ではスマートフォン版はご利用出来ません。ブラウザを開き https://www.memotta.com よりPC版にアクセスして下さい。'],
    ['msg.0130','お名前を入力して下さい。'],
    ['msg.0131','登録しました。'],
    ['msg.0132','退会しました。'],
    ['msg.0133','通報内容を入力して下さい。'],
    ['msg.0134','未公開イベントのメール送信は出来ません。'],
    ['msg.0135','選択されたファイルはアップロードファイルの上限(10MB)を超えてますので、他のファイルを選択して下さい。'],
    ['msg.0136','パラメーターが正しくありません。'],
    ['msg.0137','住所を正しく入力するとここに地図が表示されます。'],
    ['msg.0138','必須入力です。'],
    ['msg.0139','この機能をご利用頂くには会員登録後、ログインが必要です。'],
    ['msg.0140','開始時刻を設定して下さい。'],
    ['msg.0141','会員（{$1}）の登録を抹消しても宜しいですか？ この会員のポイントはすべて削除され、会員情報も参照する事は出来なくなります。'],
    ['msg.0142','入力項目を確認して下さい。'],
    ['msg.0143','ユーザー名が入力されていません。'],
    
    /* Message（msg.0201～) Memotta2サーバーで追加したメッセージ */
    ['msg.0201','ActionFlagの値が正しく設定されてません。'],
    ['msg.0202','クラスの生成に失敗しました。'],
    ['msg.0203','プロジェクトNo.が設定されてません。'],
    ['msg.0204','イベント区分が設定されてません。'],
    ['msg.0205','イベントNo.が設定されてません。'],
    ['msg.0206','システムコードが設定されてません。'],
    ['msg.0207','テンプレートコードが設定されてません。'],
    ['msg.0208','プロジェクトタイトルが設定されてません。'],
    ['msg.0209','プロジェクト公開区分が設定されてません。'],
    ['msg.0210','購読者が設定されてません。'],
    ['msg.0211','イベントタイトルが設定されてません。'],
    ['msg.0212','アクションNo.が設定されてません。'],
    ['msg.0213','プロジェクトタイトルが重複してます。'],
    ['msg.0214','ユーザーIDが設定されてません。'],
    ['msg.0215','性別が設定されてません。'],
    ['msg.0216','オーナー情報が存在しません。'],
    ['msg.0217','プロジェクト情報が存在しません。'],
    ['msg.0218','メンバーが設定されてません。'],
    ['msg.0219','メールテンプレートコードが設定されてません。'],
    ['msg.0220','役割コードが設定されてません。'],
    ['msg.0221','ユーザー情報が存在しません。'],
    ['msg.0222','開始年月日が設定されてません。'],
    ['msg.0223','メンバー招待ステータスコードが設定されてません。'],
    ['msg.0224','オプション購入ストアコードが設定されてません。'],
    ['msg.0225','オプションコードが設定されてません。'],
    ['msg.0226','ストアーオプションコードが設定されてません。'],
    ['msg.0227','保存用データーがありません。'],
    ['msg.0228','メンバーのユーザー情報が存在しません。'],
    ['msg.0229','Eメールアドレスの一部又は、ニックネームの一部を入力して下さい。'],
    ['msg.0230','検索結果は先頭の'],
    ['msg.0231','件のみ表示してます。'],
    ['msg.0232','メンバーを選択して下さい。'],
    ['msg.0233','国コードが設定されてません。'],
    ['msg.0234','端末IDが設定されてません。'],
    ['msg.0235','端末トークンが設定されてません。'],
    ['msg.0236','端末タイプが設定されてません。'],
    ['msg.0237','送信先が設定されてません。'],
    ['msg.0238','バーコードフォーマットが設定されてません。'],
    ['msg.0239','バーコードフォーマットが正しくありません。'],
    ['msg.0240','表示コードが設定されてません。'],
    ['msg.0241','MIMEタイプが設定されてません。'],
    ['msg.0242','画像の横幅が設定されてません。'],
    ['msg.0243','画像の高さが設定されてません。'],
    ['msg.0244','取得対象ユーザーIDが設定されてません。'],
    ['msg.0245','添付ファイルが設定されてません。'],
    ['msg.0246','オプションステータスコードが設定されてません。'],
    ['msg.0247','ユーザー設定項目コードが設定されてません。'],
    ['msg.0248','メモった！ユーザーのメンバー追加は「メモった！ユーザー検索」から行って下さい。'],
    ['msg.0249','体調公開スイッチが設定されてません。'],
    ['msg.0250','体温公開スイッチが設定されてません。'],
    ['msg.0251','血圧公開スイッチが設定されてません。'],
    ['msg.0252','脈拍公開スイッチが設定されてません。'],
    ['msg.0253','症状公開スイッチが設定されてません。'],
    ['msg.0254','アラート受信スイッチが設定されてません。'],
    ['msg.0255','体調記録が設定されてません。'],
    ['msg.0256','体調コードが設定されてません。'],
    ['msg.0257','単位コードが設定されてません。'],
    ['msg.0258','取得開始年月日が設定されてません。'],
    ['msg.0259','年月日が設定されてません。'],
    ['msg.0260','カレンダーが取得出来ませんでした。'],
    ['msg.0261','メモ番号が設定されてません'],
    ['msg.0262','メールを受信しました。24時間以内に返信がない場合は、お手数ですが再度送信をお願い致します。'],
    ['msg.0263','接続方式が設定されてません。'],
    ['msg.0264','接続端末が設定されてません。'],
    ['msg.0265','店舗名が設定されてません。'],
    ['msg.0266','検索結果が多いため{$1}件のみ表示します。'],
    ['msg.0267','店舗IDが設定されてません。'],
    ['msg.0268','指定された店舗名は既に登録済みです。場所違いによる同名店舗の場合は、アクセス、住所、電話番号等を入力し再度保存して下さい。'],
    ['msg.0269','指定された店舗は存在しません。'],
    ['msg.0270','メッセージが設定されてません。'],
    ['msg.0271','送信者アドレスが設定されてません。'],
    ['msg.0272','店舗名または店舗IDを設定して下さい。'],
    ['msg.0273','写真が設定されてません。'],
    ['msg.0274','プロジェクトお知らせ情報が設定されてません。'],
    ['msg.0275','終了年月日が設定されてません。'],
    ['msg.0276','メモカテゴリーコードが設定されてません。'],
    ['msg.1001','エラーが発生しました。'],
    ['msg.1002','サーバーに接続出来ません。ログインし直して下さい。'],
    ['msg.1003','サーバーに接続出来ないため更新は出来ません。通信状態の良い場所で[再表示]ボタンを押して下さい。'],
    ['msg.1004','戻るボタンは使用出来ません。'],
    /* Vueで追加したメッセージは2001番以降を使う */
    ['msg.2001','この機能を利用するにはログインが必要です。'],
    ['msg.2002','ログインに失敗しました。'],
    ['msg.2003','半角数字を入力して下さい。'],
    
    /* Screen contents */
    ['screen.common.companyName','エスプラナード・ワン株式会社'],
    ['screen.common.title','メモった！'],
    ['screen.common.label.uid','ユーザー番号'],
    ['screen.common.label.memo','メモ'],
    ['screen.common.label.menu','メニュー'],
    ['screen.common.label.yes','はい'],
    ['screen.common.label.no','いいえ'],
    ['screen.common.label.have','あり'],
    ['screen.common.label.notHave','なし'],
    ['screen.common.label.logout','ログアウト'],
    ['screen.common.label.return','戻る'],
    ['screen.common.label.cancel','取消'],
    ['screen.common.label.save','保存'],
    ['screen.common.label.config','設定'],
    ['screen.common.label.login','ログイン'],
    ['screen.common.label.loggedin','ログイン中'],
    ['screen.common.label.nologin','ログインしていません'],
    ['screen.common.label.apply.mem','会員登録'],
    ['screen.common.label.notice','お知らせ'],
    ['screen.common.label.notice.max','お知らせ（最大1800文字)'],
    ['screen.common.label.saveAndInvMail','保存と同時に招待メールを送信'],
    ['screen.common.label.saveAndMail','保存とメール送信'],
    ['screen.common.label.sendMail','メール送信'],
    ['screen.common.label.mail.to','メール送信先'],
    ['screen.common.label.mail.attachment','添付ファイル'],
    ['screen.common.label.delete','削除'],
    ['screen.common.label.deleteAndMail','削除とメール送信'],
    ['screen.common.label.groupMail','グループメール'],
    ['screen.common.label.groupLogo','グループロゴ'],
    ['screen.common.label.groupPhoto','グループ写真'],
    ['screen.common.label.groupName','グループ名'],
    ['screen.common.label.groupName.max','グループ名（最大30文字）'],
    ['screen.common.label.groupDesc.max','説明（最大512文字）'],
    ['screen.common.label.delete.currEvent','このイベントのみ削除'],
    ['screen.common.label.delete.currEventAndMail','このイベントのみ削除後にメール送信'],
    ['screen.common.label.delete.allEvent','全ての繰り返しイベントを削除'],
    ['screen.common.label.delete.allEventAndMail','全ての繰り返しイベントを削除後にメール送信'],
    ['screen.common.label.event.repeated.onlyThis','このイベントのみ'],
    ['screen.common.label.event.repeated.all','全ての繰り返しイベント'],
    ['screen.common.label.event.modifyTo','変更対象'],
    ['screen.common.label.delete.group','グループ削除'],
    ['screen.common.label.release.member','グループから除外'],
    ['screen.common.label.add','追加'],
    ['screen.common.label.create','新規作成'],
    ['screen.common.label.others','その他'],
    ['screen.common.label.pastDays','過去日数'],
    ['screen.common.label.days','日数'],
    ['screen.common.label.intervalDays','周期'],
    ['screen.common.label.range','範囲'],
    ['screen.common.label.period','期間'],
    ['screen.common.label.OK','了解'],
    ['screen.common.label.memID','アカウント番号'],
    ['screen.common.label.pwd','パスワード'],
    ['screen.common.label.email','Ｅメール'],
    ['screen.common.label.open','開く'],
    ['screen.common.label.close','閉じる'],
    ['screen.common.label.closeWoSave','保存しないで閉じる'],
    ['screen.common.label.enroll','登録'],
    ['screen.common.label.regist','登録'],
    ['screen.common.label.error','エラー'],
    ['screen.common.label.done','完了'],
    ['screen.common.label.sent','送信済み'],
    ['screen.common.label.neversent','未送信'],
    ['screen.common.label.proceeding','手続き中'],
    ['screen.common.label.quit','アカウント削除'],
    ['screen.common.label.recorded','記録'],
    ['screen.common.label.recordExists','記録あり'],
    ['screen.common.label.recordedTime','記録時刻'],
    ['screen.common.label.time','時刻'],
    ['screen.common.label.update','更新'],
    ['screen.common.label.updateTime','更新時刻'],
    ['screen.common.label.edit','編集'],
    ['screen.common.label.display','表示'],
    ['screen.common.label.display.cond','表示条件'],
    ['screen.common.label.display.range','表示期間'],
    ['screen.common.label.refresh','再表示'],
    ['screen.common.label.displayCond','表示条件'],
    ['screen.common.label.clear','クリア'],
    ['screen.common.label.modify','変更'],
    ['screen.common.label.detail','詳細'],
    ['screen.common.label.nolimit','無制限'],
    ['screen.common.label.content','内容'],
    ['screen.common.label.sender','送信者'],
    ['screen.common.label.send','送信'],
    ['screen.common.label.recv.allow','受信する'],
    ['screen.common.label.recv.notallow','受信しない'],
    ['screen.common.label.notify.cond','通知条件'],
    ['screen.common.label.targetDate','目標達成予定日'],
    ['screen.common.label.remainDays','残り日数'],
    ['screen.common.label.reminder.notify.time','通知予定時刻'],
    ['screen.common.label.line','行'],
    ['screen.common.label.ken','件'],
    ['screen.common.label.list.order','表示順'],
    ['screen.common.label.list.order.desc','一覧表示での表示順を1から9999の数字で入力して下さい。数字の昇順に一覧表示されます。'],
    ['screen.common.label.firstPage','先頭ページ'],
    ['screen.common.label.nextPage','次ページ'],
    ['screen.common.label.prevPage','前ページ'],
    ['screen.common.label.lastPage','最終ページ'],
    ['screen.common.label.none','無し'],
    ['screen.common.label.required','必須'],
    ['screen.common.label.any','任意'],
    ['screen.common.label.noData','未登録'],
    ['screen.common.label.within1day','1日以内'],
    ['screen.common.label.within3days','3日以内'],
    ['screen.common.label.within7days','7日以内'],
    ['screen.common.label.within31days','31日以内'],
    ['screen.common.label.within90days','90日以内'],
    ['screen.common.label.within180days','180日以内'],
    ['screen.common.label.within365days','365日以内'],
    ['screen.common.label.last7days','過去7日間'],
    ['screen.common.label.last31days','過去31日間'],
    ['screen.common.label.last90days','過去90日間'],
    ['screen.common.label.last180days','過去180日間'],
    ['screen.common.label.last365days','過去365日間'],
    ['screen.common.label.1month','１ヵ月'],
    ['screen.common.label.3month','３ヵ月'],
    ['screen.common.label.halfYear','半年'],
    ['screen.common.label.1year','１年'],
    ['screen.common.label.all','全件'],
    ['screen.common.label.y','年'],
    ['screen.common.label.mm','月'],
    ['screen.common.label.ym','年月'],
    ['screen.common.label.ymd','年月日'],
    ['screen.common.label.mmdd','月日'],
    ['screen.common.label.startTime','開始時刻'],
    ['screen.common.label.endTime','終了時刻'],
    ['screen.common.label.startYmd','開始年月日'],
    ['screen.common.label.endYmd','終了年月日'],
    ['screen.common.label.start','開始'],
    ['screen.common.label.end','終了'],
    ['screen.common.label.prevMonth','前月'],
    ['screen.common.label.nextMonth','翌月'],
    ['screen.common.label.currentMonth','今月'],
    ['screen.common.label.lastMonth','先月'],
    ['screen.common.label.endOfMonth','月末'],
    ['screen.common.label.month','月'],
    ['screen.common.label.day','日'],
    ['screen.common.label.Sunday1','日'],
    ['screen.common.label.Monday1','月'],
    ['screen.common.label.Tuesday1','火'],
    ['screen.common.label.Wednesday1','水'],
    ['screen.common.label.Thursday1','木'],
    ['screen.common.label.Friday1','金'],
    ['screen.common.label.Saturday1','土'],
    ['screen.common.label.dow1.0','日'],
    ['screen.common.label.dow1.1','月'],
    ['screen.common.label.dow1.2','火'],
    ['screen.common.label.dow1.3','水'],
    ['screen.common.label.dow1.4','木'],
    ['screen.common.label.dow1.5','金'],
    ['screen.common.label.dow1.6','土'],
    ['screen.common.label.dow2.0','日曜日'],
    ['screen.common.label.dow2.1','月曜日'],
    ['screen.common.label.dow2.2','火曜日'],
    ['screen.common.label.dow2.3','水曜日'],
    ['screen.common.label.dow2.4','木曜日'],
    ['screen.common.label.dow2.5','金曜日'],
    ['screen.common.label.dow2.6','土曜日'],
    ['screen.common.label.yearly','年間表示'],
    ['screen.common.label.monthly','月間表示'],
    ['screen.common.label.weekly','週間表示'],
    ['screen.common.label.yesterday','昨日'],
    ['screen.common.label.tomorrow','明日'],
    ['screen.common.label.today','今日'],
    ['screen.common.label.prevDay','前日'],
    ['screen.common.label.nextDay','翌日'],
    ['screen.common.label.1w','１週間'],
    ['screen.common.label.2w','２週間'],
    ['screen.common.label.3w','３週間'],
    ['screen.common.label.4w','４週間'],
    ['screen.common.label.everyday','毎日'],
    ['screen.common.label.everyweek','毎週'],
    ['screen.common.label.everymonth','毎月'],
    ['screen.common.label.repeat','繰り返し'],
    ['screen.common.label.repeatCycle','繰り返し周期'],
    ['screen.common.label.bodyWeight','体重'],
    ['screen.common.label.targetBodyWeight','目標体重'],
    ['screen.common.label.recomendedBodyWeight','理想体重'],
    ['screen.common.label.goalBodyWeight','ダイエット目標値'],
    ['screen.common.label.chgGoalBodyWeight','ダイエット目標値変更'],
    ['screen.common.label.setGoalBodyWeight','ダイエット目標値設定'],
    ['screen.common.label.currentBodyWeight','現在の体重'],
    ['screen.common.label.BodyHeight','身長'],
    ['screen.common.label.MonthlyPeriod','生理日'],
    ['screen.common.label.BodyTemperature','体温'],
    ['screen.common.label.bloodPressure','血圧'],
    ['screen.common.label.bloodPressure.graph','血圧グラフ'],
    ['screen.common.label.systolicBloodPressure','収縮期血圧'],
    ['screen.common.label.diastolicBloodPressure','拡張期血圧'],
    ['screen.common.label.Threshold.u','閾値(上)'],
    ['screen.common.label.Threshold.l','閾値(下)'],
    ['screen.common.label.barcode.dsp','バーコード表示'],
    ['screen.common.label.Photo','画像'],
    ['screen.common.label.Zoomin','拡大'],
    ['screen.common.label.Zoomout','縮小'],
    ['screen.common.label.reconnect','サーバーへ再接続'],
    ['screen.common.label.daily','デイリー'],
    ['screen.common.label.confirm','確認'],
    ['screen.common.label.connecting','サーバー接続中'],
    ['screen.common.label.function','機能'],
    ['screen.common.label.scanQR1','下のQRコードをスキャンして下さい。'],
    ['screen.common.label.scanQR2','アプリがインストされている場合にはアプリを起動、インストールされてない場合はストアへ移動します。'],
    ['screen.common.label.scanQR3','アプリストアへのQRコード'],
    ['screen.common.label.ymdMemo','メモ年月日'],
    ['screen.common.label.tsAdd','記録日時'],
    ['screen.common.label.upperLimit','上限'],
    ['screen.common.label.help','説明'],
    ['screen.common.label.desc','説明'],
    ['screen.common.label.example','例'],
    ['screen.common.label.remark','備考'],
    ['screen.common.label.refer.url','参照URL'],
    ['screen.common.label.linkpage','リンクページ'],
    ['screen.common.label.notify','通知'],
    ['screen.common.label.notify.rsrvd','通知予定'],
    ['screen.common.label.notify.done','通知済み'],
    ['screen.common.label.groupList.owned','所有しているグループ'],
    ['screen.common.label.groupList.managed','管理しているグループ'],
    ['screen.common.label.groupList.invited','招待されたグループ'],
    ['screen.common.label.information','インフォメーション'],
    ['screen.common.label.help','ヘルプ'],
    ['screen.common.label.memoRecordStatus','メモ記録状況'],
    ['screen.common.label.cntMemoToday','本日のメモ記録件数'],
    ['screen.common.label.cntMemoRemainToday','本日のメモ追加可能件数'],
    ['screen.common.label.cntMemoTotal','メモ合計記録件数'],
    ['screen.common.label.cntMemoObjectTotal','画像合計記録枚数'],
    ['screen.common.label.ratioMemoObjectTotal','画像記録済み容量'],
    ['screen.common.label.consecutive','連続作成'],
    ['screen.common.label.prodInfo','製品情報'],
    ['screen.common.label.prodName','製品名'],
    ['screen.common.label.version','バージョン'],
    ['screen.common.label.developer','開発元'],
    ['screen.common.label.aboutMemotta','メモった！とは'],
    ['screen.common.label.contactUs','お問い合せ'],
    ['screen.common.label.beforeUse','ご利用にあたって'],
    ['screen.common.label.currentPlan','現在の料金プラン'],
    ['screen.common.label.plan','料金プラン'],
    ['screen.common.label.plan_00','無料プラン'],
    ['screen.common.label.plan_10','有料プラン'],
    ['screen.common.label.plan.name.memotta_plan_10','メモった！有料プラン（１ヵ月更新）'],
    ['screen.common.label.plan.list','料金プラン一覧'],
    ['screen.common.label.plan.conf','有料プランを購入されますか？'],
    ['screen.common.label.plan.close.nopurchase','有料プランを購入しないで閉じる'],
    ['screen.common.label.purchase','購入'],
    ['screen.common.label.account','アカウント'],
    ['screen.common.label.createNewAccount','アカウント新規作成'],
    ['screen.common.label.showOnCal','カレンダー表示設定'],
    ['screen.common.label.confirmInput','入力確認'],
    ['screen.common.label.confirmInput.desc','入力項目が正しければ登録ボタンを押して下さい。間違っている場合は戻るボタンで入力画面に戻ります。'],
    ['screen.common.label.regInProgress','仮登録完了'],
    ['screen.common.label.showOnCal.desc','カレンダーに下のアイコンを表示する'],
    ['screen.common.label.bbt','体温'],
    ['screen.common.label.disp.items','表示項目'],
    ['screen.common.label.showPDF','PDF表示'],
    ['screen.common.label.title','タイトル'],
    ['screen.common.label.expectedDay','次回予定日'],
    ['screen.common.label.participation','参加'],
    ['screen.common.label.noParticipation','不参加'],
    ['screen.common.label.refusal','拒否'],
    ['screen.common.label.allow','許可'],
    ['screen.common.label.unknown','不明'],
    ['screen.common.label.NoResponse','未回答'],
    ['screen.common.label.operation','操作'],
    ['screen.common.label.profile','プロフィール'],
    ['screen.common.label.aboutThisPage','このページの説明'],
    ['screen.common.label.name','名前'],
    ['screen.common.label.nickname','ニックネーム'],
    ['screen.common.label.nicknameInGroup','グループ内ニックネーム'],
    ['screen.common.label.nicknameInGroup.desc','グループ内で表示される名前です。'],
    ['screen.common.label.invitation','招待状'],
    ['screen.common.label.invitation.send','招待状メール送付'],
    ['screen.common.label.invitation.sent','招待状メール送付済'],
    ['screen.common.label.invitation.neversend','招待状メール未送信'],
    ['screen.common.label.invitation.status','招待ステータス'],
    ['screen.common.label.gt','以上'],
    ['screen.common.label.lt','以下'],
    ['screen.common.label.or','又は'],
    ['screen.common.label.everybody','全員'],
    ['screen.common.label.mem.selectedOnly','選択したメンバーのみ'],
    ['screen.common.label.select','選択'],
    ['screen.common.label.select.all','全選択'],
    ['screen.common.label.select.cancel','選択解除'],
    ['screen.common.label.select.mem','メンバー選択'],
    ['screen.common.label.select.file.desc','ファイルを選択して下さい'],
    ['screen.common.label.selected.mem.cnt','選択済み件数'],
    ['screen.common.label.search','検索'],
    ['screen.common.label.search.condition','検索条件'],
    ['screen.common.label.search.cond','絞り込み条件'],
    ['screen.common.label.search.ymd','年月日検索'],
    ['screen.common.label.search.title','タイトル検索'],
    ['screen.common.label.search.body','本文検索'],
    ['screen.common.label.search.cond.all','全てを含む'],
    ['screen.common.label.search.cond.part','いずれかを含む'],
    ['screen.common.label.search.cond.none','含めない'],
    ['screen.common.label.search.result','検索結果'],
    ['screen.common.label.search.result.cnt','検索件数'],
    ['screen.common.label.search.decided','決定'],
    ['screen.common.label.participation.stts','参加状況'],
    ['screen.common.label.numOfGruops','グループ数'],
    ['screen.common.label.group.publish','グループを公開する'],
    ['screen.common.label.group.publish.desc','グループを公開するすると全会員にグループのカレンダーが公開されます'],
    ['screen.common.label.publish.period','公開期間'],
    ['screen.common.label.coupon','クーポン'],
    ['screen.common.label.coupon.name','クーポン名称'],
    ['screen.common.label.coupon.code','クーポンコード'],
    ['screen.common.label.cmnt','コメント'],
    ['screen.common.label.sendingMessage','送信メッセージ'],
    ['screen.common.label.numOfMems','メンバー数'],
    ['screen.common.label.numOfCustomer','会員数'],    
    ['screen.common.label.mode.personal','パーソナル'],
    ['screen.common.label.mode.group','グループ'],
    ['screen.common.label.mode.mypage','マイページ'],
    ['screen.common.label.mode.mygroup','マイグループ'],
    ['screen.common.label.mode.favor','お気に入り'],
    ['screen.common.label.mode.standard','一般用'],
    ['screen.common.label.mode.shoponly','店舗用'],
    ['screen.common.label.add.event','イベント登録'],
    ['screen.common.label.event.ymd','開催年月日'],
    ['screen.common.label.event.time','開催時間'],
    ['screen.common.label.event.place','開催場所'],
    ['screen.common.label.meeting.place','集合場所'],
    ['screen.common.label.meeting.time','集合時刻'],
    ['screen.common.label.terms','利用規約'],
    ['screen.common.label.policy','プライバシーポリシー'],
    ['screen.common.label.attndnc','出欠'],
    ['screen.common.label.attndnc.mng','出欠管理'],
    ['screen.common.label.attndnc.input','出欠入力'],
    ['screen.common.label.attndnc.inputable','出欠入力あり'],
    ['screen.common.label.attndnc.byYmd','出欠回答期限'],
    ['screen.common.label.attndnc.0','欠席'],
    ['screen.common.label.attndnc.1','出席'],
    ['screen.common.label.attndnc.2','保留'],
    ['screen.common.label.attndnc.3','遅刻'],
    ['screen.common.label.attndnc.4','早退'],
    ['screen.common.label.attndnc.5','見学'],
    ['screen.common.label.attndnc.X','未回答'],
    ['screen.common.label.attndnc.prsn.0','欠席者'],
    ['screen.common.label.attndnc.prsn.1','出席者'],
    ['screen.common.label.attndnc.prsn.2','保留者'],
    ['screen.common.label.attndnc.prsn.3','遅刻者'],
    ['screen.common.label.attndnc.prsn.4','早退者'],
    ['screen.common.label.attndnc.prsn.5','見学者'],
    ['screen.common.label.attndnc.prsn.X','未回答者'],
    ['screen.common.label.attndnc.psblty','出席確率'],
    ['screen.common.label.attndnc.answer.byYmd','回答期限'],
    ['screen.common.label.attndnc.show','出欠一覧をメンバーに公開する'],
    ['screen.common.label.membership.no','会員番号'],
    ['screen.common.label.membership.delete','会員削除'],
    ['screen.common.label.roll','役割'],
    ['screen.common.label.roll.01','所有者'],
    ['screen.common.label.roll.02','管理者'],
    ['screen.common.label.roll.03','利用者'],
    ['screen.common.label.roll.04','スタッフ'],
    ['screen.common.label.roll.05','会員'],
    ['screen.common.label.startMemotta','メモった！を始める'],
    ['screen.common.label.category.0001','メモ'],
    ['screen.common.label.category.0002','画像'],
    ['screen.common.label.category.0301','体重'],
    ['screen.common.label.category.0304','生理日'],
    ['screen.common.company.url','https://www.esplanadeone.com/jpn/'],
    ['screen.common.desc.iframe','iframe対応のブラウザーをお使い下さい'],
    ['screen.common.desc.pressSaveBtn','変更した場合は、画面下の保存ボタンを押して下さい。'],
    ['screen.common.label.sendMail.desc1','送信先を選択すると保存又は削除と同時にメールが送信されます。'],
    ['screen.common.label.pleaseWait','少々お待ち下さい'],
    ['screen.common.label.shopCal','店舗カレンダー'],
    ['screen.common.label.openByApp','アプリで開く'],
    ['screen.common.label.openByWeb','ブラウザーで開く'],
    ['screen.common.label.confirmInput.01','表示内容が正しければ確定をタップして下さい。'],
    ['screen.common.label.confirm','確定'],
    ['screen.common.label.save.member','会員情報保存'],
    ['screen.common.label.honorificTitle','様'],
    ['screen.common.label.unread','未読'],
    ['screen.common.label.chat.unread','チャット未読'],
    ['screen.common.label.chat.wrote','チャット書き込み'],
    ['screen.common.label.chat.wrote.dt','書き込み日時'],

    ['screen.common.color.foreground.plan_00','#4169e1'],
    ['screen.common.color.foreground.plan_10','#ffb03f'],
    
    /* セパレーター */
    ['screen.common.separator1','：'],
    ['screen.common.separator2','　'],
    
    ['screen.error.title','エラー発生'],
    
    ['screen.P101002.title','メモ作成/編集'],
    ['screen.P101002.saveMemo','メモを保存'],
    ['screen.P101002.label.uploadPhoto','画像のアップロード／削除'],
    ['screen.P101002.label.upload','アップロード'],
    ['screen.P101002.label.uploadedPhotos','アップロード済み画像'],
    ['screen.P101002.label.photoFilename','イメージ（写真）ファイル名'],
    ['screen.P101002.label.desc1','画像ファイル名を入力後、アップロードボタンをタップすると画像がサーバーに登録され、下に表示されます'],
    ['screen.P109002.label.title.desc','タイトル（30文字以内）'],
    ['screen.P109002.label.memo.desc','メモ（128文字以内）'],
    
    ['screen.P101003.title','メモ検索'],
    ['screen.P101003.label.memotitle','タイトル'],
    ['screen.P101003.label.memobody','本文'],
    ['screen.P101003.label.cond1','検索条件'],
    ['screen.P101003.label.cond2_1','検索キーワードを下のＢＯＸに入力して下さい。'],
    ['screen.P101003.label.cond2_2','複数キーワードは空白で区切って下さい。'],
    ['screen.P101003.label.cond2_3','（例) ディズニーランド デート'],
    ['screen.P101003.label.cond3','全てを含む'],
    ['screen.P101003.label.cond4','いずれかを含む'],
    ['screen.P101003.label.cond5','含めない'],
    ['screen.P101003.label.cond6','年月日'],
    ['screen.P101003.label.cond8','検索件数'],
    ['screen.P101003.label.result1','検索結果'],
    ['screen.P101003.label.result2','選択したメモを削除'],
    
    ['screen.P101004.title','画像表示'],
    
    ['screen.P101005.title','日記編集'],
    
    ['screen.P101010.title','マイページ'],
    
    ['screen.P101011.title','月間カレンダー'],
    ['screen.P101011.label.items','表示項目'],
    ['screen.P101011.label.showPopup','ポップアップ表示'],
    ['screen.P101011.label.addMemo','メモ追加'],
    ['screen.P101011.label.saveRemark','備考を保存'],
    ['screen.P101011.label.zoomin','詳細表示'],
    
    ['screen.P101012.title','メニュー'],
    ['screen.P101012.label.info','お知らせ'],
    ['screen.P101012.menu.memo','メモ'],
    ['screen.P101012.menu.bodyMemo','からだ管理'],
    ['screen.P101012.menu.profile','プロフィール'],
    ['screen.P101012.menu.contactUs','お問い合せ'],
    ['screen.P101012.menu.confirmLogout','ログアウトしますか？'],
    ['screen.P101012.menu.personal','パーソナル'],
    ['screen.P101012.menu.group','グループ'],
    ['screen.P101012.menu.help','このページの説明'],
    
    ['screen.P103010.title','体重・ダイエット'],
    ['screen.P103010.label.boduWeightGraph','体重グラフ'],
    ['screen.P103010.label.boduWeightTable','体重表'],
    ['screen.P103010.comment1','目標達成まであと<<1>>、残り<<2>>日 頑張りましょう！'],
    ['screen.P103010.comment2','目標達成おめでとうございます！'],
    ['screen.P103010.comment3','目標達成まであと<<1>>。目標達成予定日が過ぎていますので新たな予定日を設定して下さい。'],
    
    ['screen.P103011.label.title','目標体重設定'],
    
    ['screen.P103012.label.title','身長設定'],
    
    ['screen.P103020.title','基礎体温'],
    ['screen.P103020.label.inputBBT','基礎体温入力（過去60日）'],
    ['screen.P103020.label.recorded','記録（過去60日）'],
    
    ['screen.P103040.title','生理日'],
    ['screen.P103040.label.inputPeriod','生理日入力'],
    ['screen.P103040.label.inPeriod','生理中'],
    
    /* 体調管理 */
    ['screen.P103060.title','体温・体調・血圧'],
    ['screen.P103060.label.inputCurPhysclCnd','現在の体調を記録'],
    ['screen.P103060.label.pastList','過去の記録'],
    ['screen.P103060.label.pc.1','良い'],
    ['screen.P103060.label.pc.2','普通'],
    ['screen.P103060.label.pc.3','不調'],
    ['screen.P103060.label.pc.4','悪い'],
    ['screen.P103060.label.cond','体調'],
    ['screen.P103060.label.bp','血圧'],
    ['screen.P103060.label.bpu','血圧(上)'],
    ['screen.P103060.label.bpl','血圧(下)'],
    ['screen.P103060.label.bp.avg','平均血圧'],
    ['screen.P103060.label.bpu.avg','平均血圧(上)'],
    ['screen.P103060.label.bpl.avg','平均血圧(下)'],
    ['screen.P103060.label.bp.morning','朝血圧'],
    ['screen.P103060.label.bpu.morning','朝血圧(上)'],
    ['screen.P103060.label.bpl.morning','朝血圧(下)'],
    ['screen.P103060.label.bp.night','夜血圧'],
    ['screen.P103060.label.bpu.night','夜血圧(上)'],
    ['screen.P103060.label.bpl.night','夜血圧(下)'],
    ['screen.P103060.label.bp.ave','平均血圧'],
    ['screen.P103060.label.bp.max','最高血圧'],
    ['screen.P103060.label.hb','脈拍'],
    ['msg.P103060.001','熱が下がりませんね、お医者さんへ行きましょう。'],
    ['msg.P103060.002','あまり無理をしないで下さいね、今日は早く休みましょう。'],
    ['msg.P103060.003','体調が良くありませんね、ゆっくり休んで下さい。'],
    
    ['screen.P109001.title','アカウント新規作成'],
    ['screen.P109001.label.title','アカウント新規作成'],
    ['screen.P109001.label.next','次へ進む'],
    ['screen.P109001.label.email','Ｅメール'],
    ['screen.P109001.label.nickname','ニックネーム'],
    ['screen.P109001.label.nickname.desc','３０文字以内、個人情報保護のため本名は入力しないで下さい。'],
    ['screen.P109001.label.gender','性別'],
    ['screen.P109001.label.gender.m','男性'],
    ['screen.P109001.label.gender.f','女性'],
    ['screen.P109001.label.gender.none','未設定'],
    ['screen.P109001.label.dob','生年月日'],
    ['screen.P109001.label.year','年'],
    ['screen.P109001.label.month','月'],
    ['screen.P109001.label.day','日'],
    ['screen.P109001.label.address','居住地'],
    ['screen.P109001.label.ken','居住県を選択して下さい'],
    ['screen.P109001.label.country','居住国を選択して下さい'],
    ['screen.P109001.label.liveInJapan','日本にお住まいの方'],
    ['screen.P109001.label.liveInOversea','海外にお住まいの方'],
    ['screen.P109001.label.pwd','パスワード'],
    ['screen.P109001.label.reenter','パスワード再入力'],
    ['screen.P109001.label.desc1','パスワードの文字数は６文字以上１６文字以下です。'],
    ['screen.P109001.label.desc2','パスワードには以下の文字（大文字、小文字の英字、数字）がご利用頂けます。'],
    ['screen.P109001.label.optionBelow','これより下はオプションです'],
    
    ['screen.P109001.msg.email','Ｅメールアドレスを半角で入力して下さい。'],
    ['screen.P109001.msg.gender','性別を選択して下さい。'],
    ['screen.P109001.msg.dob','生年月日を入力して下さい。'],
    ['screen.P109001.msg.address','居住地（都道府県又は国名）を選択して下さい。'],
    
    ['screen.P109002.title','アカウント登録手続き中'],
    ['screen.P109002.desc1','アカウント仮登録が完了しました。'],
    ['screen.P109002.desc2','ご登録Eメールアドレスにアカウント登録確認メールが送信されますのでログインを行って下さい。'],
    ['screen.P109002.desc3','アカウント登録確認メールが届かない場合は、お手数ですが再度ご登録のお手続きを行って下さい。'],
    
    ['screen.P109003.title','ログイン'],
    ['screen.P109003.label.login','ログイン'],
    ['screen.P109003.label.user.existing','既に登録済みの方'],
    ['screen.P109003.label.usr.new','初めてお使いになる方はこちらから'],
    ['screen.P109003.label.beginMemotta','メモった！を始める'],
    ['screen.P109003.msg.idempty','アカウント番号を入力して下さい。'],
    ['screen.P109003.msg.pwdempty','パスワードを入力して下さい。'],
    
    
    ['screen.P109004.title','プロフィール変更'],
    ['screen.P109004.label.title','プロフィール変更'],
    ['screen.P109004.label.desc1','【ご注意】'],
    ['screen.P109004.label.desc2','Eメールアドレスを変更した場合は、新旧Eメールアドレスに変更通知が送信されます。'],
    
    ['screen.P109005.title','パスワード変更'],
    ['screen.P109005.label.currentPwd','現在のパスワード'],
    ['screen.P109005.label.newPwd','新パスワード'],
    ['screen.P109005.label.reenter','新パスワード再入力'],
    
    ['screen.P109006.title','アカウント削除'],
    ['screen.P109006.label.desc1','アカウント削除を希望される場合は、下のアカウント削除ボタンを押して下さい。'],
    ['screen.P109006.label.desc2','アカウント削除が完了すると「メモった！」、「健康管理onメモった！」、「キニッタ！グルメ」に保存されているデーターは全て削除されます。'],
    ['screen.P109006.label.conf','アカウントを削除しますか？「メモった！」、「健康管理onメモった！」、「キニッタ！グルメ」に保存されているデーターは全て削除され、ログインも出来なくなります。'],
    ['screen.P109006.desc1','ご利用有難う御座いました。アカウント削除処理が完了致しました。'],
    
    ['screen.P109008.title','メールでのお問い合せ'],
    
    ['screen.P109009.title','お問い合せ'],
    ['screen.P109009.msg.name','名前を入力して下さい。'],
    ['screen.P109009.msg.email.ne','入力された２つのＥメールアドレスが等しくありません。再度入力して下さい。'],
    ['screen.P109009.msg.approved','お問い合わせ承りました。２４時間以内に返信が御座いません場合は、お手数ですが再度ご送信下さい。'],
    ['screen.P109009.label.content','お問い合せ内容'],
    ['screen.P109009.label.name','お名前'],
    ['screen.P109009.label.email','Eメールアドレス'],
    ['screen.P109009.label.re-email','上と同じEメールアドレスを再入力して下さい'],
    
    ['screen.P110001.title','メッセージ画面'],
    
    ['screen.M109001.label.ken','県'],
    ['screen.M109001.label.country','国'],
    ['screen.M109001.label.loginNow','今すぐログイン'],
    ['screen.M109002.desc1','アカウント登録ありがとうございました。'],
    ['screen.M109002.desc2','５分以内にご登録Eメールアドレスにアカウント登録確認メールが送信されます。'],
    ['screen.M109002.desc3','１５分以内に「メモった！」又は「健康管理onメモった！」のどちらかにログインされなかった場合は、お手数ですが再度ご登録のお手続きを行って下さい。'],
    ['screen.M109002.desc4','アカウント登録確認メールが届かない場合もお手数ですが再度ご登録のお手続きを行って下さい。'],
    
    /* TODO vue移植後にMessage01を作成して、そこに移動する */
    /*#################################### */
    /* メモった2用 */  
    /*#################################### */
    ['screen.login.email.desc','「メモった！」、「健康管理onメモった！」は同じEメールでログインお使い頂けます。'],
    ['screen.login.pwd.forgot','パスワードをお忘れの方'],
    ['screen.s00001001.title','アカウント新規作成'],
    ['screen.s00001002.title','入力確認'],
    ['screen.s00001003.title','プロフィール変更'],
    ['screen.s00001004.title','パスワード変更'],
    ['screen.s00001005.title','アカウント削除'],
    ['screen.s00001006.title','メールでのお問い合せ'],
    ['screen.s00001007.title','アカウント情報表示'],
    ['screen.s00001008.title','ご確認'],
    ['screen.s00001009.title','設定'],
    ['screen.s00001009.labe.grpsrh','検索によるグループ追加を許可'],
    ['screen.s00001009.labe.grpsrh.desc','許可を選択すると他のメモった！ユーザーがあなたのニックネーム、メールアドレスを検索しグループへ招待する事が出来ます。'],
    ['screen.s00001011.title','PDF表示設定'],
    ['screen.s00001011.desc','PDFに表示するタイトルの置き換え、メモの追加が可能です。'],
    ['screen.s00001012.title','お知らせ'],
    ['screen.s00001013.title','お知らせ'],
    ['screen.s00001014.title','入力候補一覧'],
    ['screen.s00001015.title','地図'],
    /* カレンダーonメモった！(01)'] */
    ['screen.memotta.01.title','メモった！'],
    ['screen.memotta.01.about','メモった！とは'],
    ['screen.s01001002.title','マイページ'],
    ['screen.s01001003.title','デイリーカレンダー'],
    ['screen.s01001003.title.short','デイリー'],
    ['screen.s01001004.title','メモ追加/変更/削除'],
    ['screen.s01001004.title1','メモ追加'],
    ['screen.s01001004.title2','メモ変更/削除'],
    ['screen.s01001004.label.remind.desc1','開始日時の'],
    ['screen.s01001004.label.remind.desc2','日'],
    ['screen.s01001004.label.remind.desc3','時間'],
    ['screen.s01001004.label.remind.desc4','分前'],
    ['screen.s01001004.label.remind.desc5','通知時刻を指定して下さい'],
    ['screen.s01001005.title','メモった！'],
    ['screen.s01001006.title','メモ検索'],
    ['screen.s01001007.title','生理日管理'],
    ['screen.s01001007.label.inputPeriod','生理日入力'],
    ['screen.s01001007.label.inPeriod','生理中'],
    ['screen.s01001008.title','基礎体温管理'],
    ['screen.s01001008.label.inputBBT','体温入力'],
    ['screen.s01001008.label.recorded','記録（過去60日）'],
    ['screen.s01001009.title','画像表示'],
    ['screen.s01001010.title','メモ記録状況'],
    ['screen.s01001012.title','メモ詳細表示'],
    ['screen.s01001011.title','メモった！インストール方法'],
    ['screen.s01001051.title','グループ一覧'],
    ['screen.s01001052.title','グループ追加'],
    ['screen.s01001052.title1','グループ追加'],
    ['screen.s01001052.title2','グループ編集'],
    ['screen.s01001053.title','メンバー一覧'],
    ['screen.s01001054.title','メンバー追加'],
    ['screen.s01001054.desc1','メモった！アカウントをお持ちのユーザーを追加する場合'],
    ['screen.s01001054.desc2','下のボタンを押して下さい。'],
    ['screen.s01001054.desc3','メモった！アカウントをお持ちでないユーザーを追加する場合'],
    ['screen.s01001054.desc4','以下の項目を入力後、「保存と同時に招待メールを送信」ボタンを押して下さい。登録したEメールアドレスに招待メールが送信されます。'],
    ['screen.s01001054.username.desc','グループ内でのニックネームです。既存メモった！ユーザーの場合には既に設定済みのニックネームが利用されます。'],
    ['screen.s01001055.title','メモった！ユーザー検索'],
    ['screen.s01001055.desc1','Eメール又は、ニックネームを入力して下さい。その後、検索結果からメンバーを選択し画面下の[保存と同時に招待メールを送信]ボタンを押して下さい。'],
    ['screen.s01001055.desc2','【注意】検索を拒否しているユーザーは検索結果に表示されません。各ユーザーは[メニュー]-[プロフィール]-[設定]で許可/拒否を切り替える事が出来ます。'],
    ['screen.s01001055.desc.eml','Eメールの一部又は全て'],
    ['screen.s01001055.desc.nickname','ニックネームの一部又は全て'],
    ['screen.s01001056.title','グループ内ニックネーム/役割/表示順変更'],
    ['screen.s01001057.title','グループ内ニックネーム変更'],
    ['screen.s01001058.title','グループホーム'],
    ['screen.s01001058.title.short','グループホーム'],
    ['screen.s01001058m.edit','イベント編集'],
    ['screen.s01001058m.disp','イベント詳細表示'],
    ['screen.s01001059.title','グループデイリーカレンダー'],
    ['screen.s01001059.title.short','デイリー'],
    ['screen.s01001060.title','イベント登録/編集/削除'],
    ['screen.s01001060.title.menu','イベント登録'],
    ['screen.s01001060.label.barcode.desc','入力したクーポンコードはNW-7(CODABAR)フォーマットで表示されます。利用できる文字は 0～9、$、:、/、.、+、- のみです。'],
    ['screen.s01001060.label.remind','リマインダー設定'],
    ['screen.s01001060.label.remind.desc1','開催日時の'],
    ['screen.s01001060.label.remind.desc2','日'],
    ['screen.s01001060.label.remind.desc3','時間前'],
    ['screen.s01001060.label.remind.desc4','分前'],
    ['screen.s01001060.label.remind.desc5','通知時刻を指定して下さい'],
    ['screen.s01001060.label.repeat.1.desc0','【ご注意】一度登録したイベントの繰り返し設定を変更する事は出来ません。周期、終了年月日等を変更する場合は全ての繰り返しイベントを削除後、新規に登録し直して下さい。'],
    ['screen.s01001060.label.repeat.1.desc1','日間隔で'],
    ['screen.s01001060.label.repeat.1.desc2','まで'],
    ['screen.s01001060.label.repeat.2.desc1','１．繰り返し曜日を選択して下さい'],
    ['screen.s01001060.label.repeat.2.desc2','２．間隔と終了年月日を入力して下さい'],
    ['screen.s01001060.label.repeat.2.desc3','週間隔で'],
    ['screen.s01001060.label.repeat.3.desc1','１．繰り返し日を選択して下さい'],
    ['screen.s01001060.label.repeat.3.desc2','ヵ月間隔で'],
    ['screen.s01001061.title','イベント詳細表示'],
    ['screen.s01001062.title','出欠一覧'],
    ['screen.s01001063.title','イベントリマインドメール送信'],
    ['screen.s01001064.title','グループメール送信'],
    ['screen.s01001064.title.short','グループメール'],
    ['screen.s01001101.title','有料プラン購入'],
    /* 健康管理onメモった！(04) */
    ['screen.memotta.04.title','健康管理onメモった！'],
    ['screen.memotta.04.about','健康管理onメモった！とは'],
    ['screen.s04001002.title','マイページ'],
    ['screen.s04001002.desc','本日の体調、血圧、脈拍、体温を入力後、保存ボタンを押して下さい。'],
    ['screen.s04001002.cond','体調'],
    ['screen.s04001002.pdf.filename','体調記録'],
    ['screen.s04001002.label.physicCondList','体調記録'],
    ['screen.s04001003.title','体重・ダイエット'],
    ['screen.s04001004.title','ダイエット目標値設定'],
    ['screen.s04001005.title','メモった！'],
    ['screen.s04001006.title','グループ一覧'],
    ['screen.s04001006.label.groupName','グループ名'],
    ['screen.s04001006.label.groupName.max','グループ名（最大30文字）'],
    ['screen.s04001006.desc','グループに参加した場合、あなたが記録した体温、血圧、体調はグループ所有者と管理者から閲覧可能となります。公開したくない場合は、プライバシー設定で非公開にして下さい。'],
    ['screen.s04001007.title','グループ追加'],
    ['screen.s04001007.title1','グループ追加'],
    ['screen.s04001007.title2','グループ編集'],
    ['screen.s00001007.label.conf_00_10','有料プランを購入されますか？'],
    ['screen.s04001008.title','メンバー一覧'],
    ['screen.s04001008.label.confMemHealth','メンバー体調確認'],
    ['screen.s04001009.title','メンバー追加'],
    ['screen.s04001009.desc1','メモった！アカウントをお持ちのユーザーを追加する場合'],
    ['screen.s04001009.desc2','下のボタンを押して下さい。'],
    ['screen.s04001009.desc3','メモった！アカウントをお持ちでないユーザーを追加する場合'],
    ['screen.s04001009.desc4','以下の項目を入力後、「保存と同時に招待メールを送信」ボタンを押して下さい。登録したEメールアドレスに招待メールが送信されます。'],
    ['screen.s04001009.username.desc','グループ内で表示されるニックネームです。'],
    ['screen.s04001011.title','メンバー体調確認'],
    ['screen.s04001011.title.short','体調確認'],
    ['screen.s04001011.label.physicCondList','メンバー体調一覧'],
    ['screen.s04001011.label.period.cond','又は、下の期間を選択して下さい。'],
    ['screen.s04001011.pdf.filename','体調一覧'],
    ['screen.s04001012.title','メンバー選択'],
    ['screen.s04001012.selectMem','対象メンバー選択'],
    ['screen.s04001013.title','メモった！ユーザー検索'],
    ['screen.s04001013.desc1','Eメール又は、ニックネームを入力して下さい。その後、検索結果からメンバーを選択し画面下の[保存と同時に招待メールを送信]ボタンを押して下さい。'],
    ['screen.s04001013.desc2','【注意】検索を拒否しているユーザーは検索結果に表示されません。各ユーザーは[メニュー]-[プロフィール]-[設定]で許可/拒否を切り替える事が出来ます。'],
    ['screen.s04001013.desc.eml','Eメールの一部又は全て'],
    ['screen.s04001013.desc.nickname','ニックネームの一部又は全て'],
    ['screen.s04001014.title','グループ内ニックネーム/役割/表示順変更'],
    ['screen.s04001015.title','グループ内ニックネーム変更'],
    ['screen.s04001016.title','体調異常アラート受信設定'],
    ['screen.s04001016.title.short','アラート設定'],
    ['screen.s04001016.desc','メンバーの体調異常アラート受信設定です。'],
    ['screen.s04001016.label.cond1','が'],
    ['screen.s04001016.label.cond2','日以上連続'],
    ['screen.s04001016.label.physicCond','体調（不調・悪い）'],
    ['screen.s04001017.title','プライバシー設定'],
    ['screen.s04001017.title.short','プライバシー'],
    ['screen.s04001017.desc','グループ所有者、管理者に公開する項目を選択して下さい。'],
    ['screen.s04001018.title','グループメール送信'],
    ['screen.s04001018.title.short','グループメール'],
    ['screen.s04001019.title','グループホーム'],
    ['screen.s04001020.title','健康管理onメモった！インストール方法'],
    ['msg.c040020.01','{$1}以上の体温が{$2}日以上続いてます。'],
    ['msg.c040020.02','体調不良が{$1}日以上続いてます。'],
    ['msg.c040020.03','{$1}以上の血圧（上）が{$2}日以上続いてます。'],
    ['msg.c040020.04','{$1}以上の血圧（下）が{$2}日以上続いてます。'],
    ['screen.s04001101.title','有料プラン購入'],
    
    /* 環境 */
    ['stimezone','JST'],
    
    /*------------------------------------- */
    /* ストア情報 */
    /*------------------------------------- */
    /*メモった！2用 */
    ['sstore.product.id.Alias.01.10','メモった！有料プラン（１ヵ月更新）'],
    /* 健康管理用 */
    ['sstore.product.id.Alias.04.10','健康管理onメモった！有料プラン（１ヵ月更新）'],
    
    ]);